import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import classes from '../index.module.scss'
import { getPortfolios } from '../store/thunk'
import { PortfolioList } from './PortfolioList'
import { SelectPortfolio } from './SelectPortfolio'

const MAX_PORTFOLIOS = 300

export const ApplyPortfolios = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getPortfolios({ Page: 1, PageSize: MAX_PORTFOLIOS }))
  }, [])

  return (
    <Element
      className={classes.applyPortfolios}
      style={{ backgroundColor: '#F9F9F9' }}
    >
      <Element style={{ color: '#3A414B' }}>
        <Element className="fw600">
          <Translate value="alertSetting.APPLY_TO_PORTFOLIOS" />
        </Element>
        <Element className={`${classes.mt2} fstItalic`}>
          <Translate value="alertSetting.APPLY_TO_PORTFOLIOS_NOTE" />
        </Element>
      </Element>

      <SelectPortfolio />

      <PortfolioList />
    </Element>
  )
}
